import { jsx, jsxs } from "react/jsx-runtime";
import { Breakpoint } from "@wix/form-fields";
import classNames from "classnames";
import React, { forwardRef, useState, useMemo } from "react";
import { TRANSLATIONS_NAMESPACE } from "../../constants/translations.js";
import { DisabledFormOverlay } from "./disabled-form-overlay.js";
import { FormViewerProvider } from "./form-viewer-provider.js";
import styles from "./form-viewer-static.module.scss";
import { FormRoot } from "../form/form-root.js";
const FormViewerStatic = forwardRef(
  ({
    form,
    i18n,
    isMobile,
    isRTL,
    config = null,
    readOnly = false,
    externalData,
    bi,
    biFormFillSessionId,
    translations,
    localeDataset,
    forcedState,
    httpClient,
    panorama,
    experiments,
    currency,
    fields,
    WixRicosViewer,
    breakpoint = Breakpoint.LARGE,
    allowFormDisable = true,
    fieldInitialData,
    validationMode,
    enableAnimations,
    ...rest
  }, forwardedRef) => {
    const { language = "en", regionalFormat = "en", userData } = config || {};
    useState(() => {
      translations && i18n.addResources(language, TRANSLATIONS_NAMESPACE, translations);
      localeDataset && i18n.addResources(language, TRANSLATIONS_NAMESPACE, localeDataset);
    });
    const formWithValidSteps = useMemo(
      () => ({
        ...form,
        steps: form?.steps?.filter((step) => step.layout?.large?.items?.length) || []
      }),
      [form]
    );
    if (!form) {
      return null;
    }
    const isDisabled = allowFormDisable && formWithValidSteps.properties?.disabled;
    return /* @__PURE__ */ jsx(React.StrictMode, { children: /* @__PURE__ */ jsx(
      FormViewerProvider,
      {
        httpClient,
        i18n,
        bi,
        panorama,
        biFormFillSessionId,
        form: formWithValidSteps,
        language,
        regionalFormat,
        isRTL,
        isMobile,
        isEditor: config?.isEditor,
        isComposer: config?.isComposer,
        externalData,
        forcedState,
        instance: config?.instance,
        experiments,
        translationNamespace: TRANSLATIONS_NAMESPACE,
        currency,
        userData,
        WixRicosViewer,
        addressTemplates: config?.addressTemplates,
        atlasBaseUrl: config?.atlasBaseUrl,
        fieldInitialData,
        compId: config?.compId,
        enableAnimations,
        baseUrl: config?.baseUrl,
        children: /* @__PURE__ */ jsxs(
          "form",
          {
            "aria-label": formWithValidSteps.properties?.name ?? "",
            id: `form-${formWithValidSteps.id}`,
            "data-hook": `form-${formWithValidSteps.id}`,
            className: classNames({
              [styles.readOnly]: readOnly,
              [styles.disabled]: isDisabled && !config?.isEditor
            }),
            onSubmit: (e) => e.preventDefault(),
            children: [
              isDisabled && /* @__PURE__ */ jsx(
                DisabledFormOverlay,
                {
                  content: formWithValidSteps.disabledFormMessage,
                  isEditor: config?.isEditor
                }
              ),
              /* @__PURE__ */ jsx(
                "fieldset",
                {
                  className: styles.fieldsetReset,
                  disabled: readOnly || isDisabled,
                  children: /* @__PURE__ */ jsx(
                    FormRoot,
                    {
                      form: formWithValidSteps,
                      fields,
                      forwardedRef,
                      config,
                      breakpoint,
                      validationMode,
                      ...rest
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) });
  }
);
export {
  FormViewerStatic
};
//# sourceMappingURL=form-viewer-static.js.map
